import * as React from "react";
import { HTMLProps, useEffect, useRef, useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  position: relative;
`;

const BGImage = styled.img`
  width: 100%;
  min-width: 100%;
  height: 100%;
  min-height: 100%;
  object-fit: contain;
`;

const FGImage = styled(BGImage)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

interface Props {
  sources: Array<HTMLProps<HTMLImageElement>["src"]>;
  alt: HTMLProps<HTMLImageElement>["alt"];
}

export const ParallaxScroll = ({ sources, alt }: Props) => {
  const [offsetY, setOffsetY] = useState(0);
  const containerRef = useRef<HTMLDivElement>();

  useEffect(() => {
    const onScroll = () => {
      const { current } = containerRef;
      if (!current) {
        throw new Error("DOM is not mounted");
      }
      const containerRect = current.getBoundingClientRect();
      const offsetYinPX =
        window.innerHeight / 2 - (containerRect.y + containerRect.height / 2);
      setOffsetY((offsetYinPX * 20) / document.documentElement.clientHeight);
    };

    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [containerRef]);

  const movingImageStyle = { transform: `translateY(${offsetY}%)` };

  return (
    <Container ref={containerRef}>
      {sources.map((src, i) =>
        i === 0 ? (
          <BGImage key={i} src={src} alt={alt} />
        ) : (
          <FGImage
            key={i}
            style={i === 1 ? movingImageStyle : {}}
            src={src}
            alt=""
          />
        )
      )}
    </Container>
  );
};
